import { render } from "./UserProfileMenue.vue?vue&type=template&id=82778c74"
import script from "./UserProfileMenue.vue?vue&type=script&lang=js"
export * from "./UserProfileMenue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__